import { render, staticRenderFns } from "./LocationDetailStatistics.vue?vue&type=template&id=5e248220"
import script from "./LocationDetailStatistics.vue?vue&type=script&lang=js"
export * from "./LocationDetailStatistics.vue?vue&type=script&lang=js"
import style0 from "./LocationDetailStatistics.vue?vue&type=style&index=0&id=5e248220&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports